import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import { LogList, ProAppProfilesProvider } from '../../../../shared/LogList';

export type ClientsActivityScreenOwnProps = {};

export type ClientsActivityScreenProps = ClientsActivityScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'clients-activity'>;
};

const ClientsActivityScreen: React.FC<ClientsActivityScreenProps> = (props) => {
    const profileNavigation = useProfilesTabNavigation();
    return (
        <ProAppProfilesProvider medicalProfileIds={props.route.params.clientMedicalProfileIds}>
            {(state) => (
                <LogList
                    {...state}
                    disableSelection
                    onLogPress={({ medicalProfileId, auditLogId }) => {
                        if (medicalProfileId) {
                            profileNavigation.navigate('client-activity-details', {
                                clientMedicalProfileId: medicalProfileId,
                                auditLogId,
                            });
                        }
                    }}
                />
            )}
        </ProAppProfilesProvider>
    );
};

export default React.memo(ClientsActivityScreen);
